import FilterFormHash from './FIlterFormHash';
import LoadingAnimationHelper from '../Helper/LoadingAnimationHelper';
import * as $ from 'jquery';

/**
 * FilterFormController
 *
 * @author Markus Hölzle <m.hoelzle@andersundsehr.com>
 * @author Thomas Schur <t.schur@andersundsehr.com>
 */
export default class FilterFormController {

  private filterInputSelector = 'select,input[type="text"],input[type="checkbox"],input[type="radio"],input[type="hidden"][data-hidden-input]';

  // set this signals for callbacks
  private signals = {
    validateShowResults: [],
    beforeShowResults: [],
    afterShowResults: [],
    beforeSetHashFromFilterForm: [],
    afterSetFilterFormFromHash: [],
  };

  private enableChangeListener = true;
  private enableHashListener = true;
  private filterRequestCount = 0;
  private isLoadingMore = false;
  private currentFilterRequest: any = null;
  private submitDataCache = '';

  /**
   * Public function to init class
   */
  constructor() {
    $('form[' + 'data-filter-form' + '="true"]').each((index, element) => {
      this.initFormSubmitListener($(element));
      this.initFormValueChangeListener($(element));
      this.initHashListener($(element));
      this.setFilterFormFromHash($(element), false);
      if ($(element).attr('data-filter-form-trigger-on-ready') === 'true') {
        $(window).trigger('hashchange');
      }
      $(window).scroll(this.getOnScrollFunction($(element)));
    });
  }

  /**
   * Add signal
   *
   * @param signalName
   * @param callback
   */
  addSignal(signalName, callback) {
    this.signals[signalName].push(callback);
  }

  /**
   * @param {jQuery} $filterForm
   */
  reInitForm($filterForm) {
    this.initFormSubmitListener($filterForm);

    $filterForm.find('select').unbind('change');
    $filterForm.find('input[type="checkbox"],input[type="radio"]').unbind('change');
    $filterForm.find('input').unbind('keypress');
    this.initFormValueChangeListener($filterForm);

    $(window).unbind('hashchange');
    this.initHashListener($filterForm);
  }

  /**
   * @param {jQuery} $form Form element
   */
  initFormSubmitListener($form) {
    $form.submit(() => {
      this.setHashFromFilterForm($form);
      return false;
    });
  }

  /**
   * @param {jQuery} $filterForm Form element
   */
  initFormValueChangeListener($filterForm) {
    $filterForm.find('select').change(() => {
      if (this.enableChangeListener) {
        $filterForm.submit();
      }
    });
    $filterForm.find('input[type="checkbox"],input[type="radio"]').change(() => {
      if (this.enableChangeListener) {
        $filterForm.submit();
      }
    });
    $filterForm.find('input').keypress((event) => {
      if (this.enableChangeListener && event.which === 13) {
        $filterForm.submit();
        event.preventDefault();
      }
    });
  }

  /**
   * @param {jQuery} $filterForm Form element
   */
  initHashListener($filterForm) {
    $(window).on('hashchange', () => {
      if (this.enableHashListener === true) {
        this.setFilterFormFromHash($filterForm, false);
        if ($filterForm.attr('data-filter-disable-ajax') !== 'true') {
          this.sendAjaxRequest($filterForm);
        } else {
          const filterElementsSelector = $filterForm.attr('data-filter-elements');
          if (filterElementsSelector) {
            this.filterElementsByClass($(filterElementsSelector), $filterForm);
          }
        }
      }
    });
  }

  /**
   * @param {jQuery} $filterForm Form element
   * @param {bool} nextUrl Form element
   */
  sendAjaxRequest($filterForm, nextUrl?) {
    const formSubmitData = $filterForm.serialize();
    if (formSubmitData !== this.submitDataCache || nextUrl) { // check little submit cache
      this.submitDataCache = formSubmitData;

      let actionUrl = '';
      if (nextUrl) {
        actionUrl = nextUrl;
      } else {
        actionUrl = $filterForm.attr('action');
        $($filterForm.attr('data-ajax-target'))
          .find(':not( ' + '.js-do-not-remove' + ', ' + '.js-do-not-remove' + ' *)')
          .remove();
      }

      const $ajaxTarget = $($filterForm.attr('data-ajax-target'));
      const $buttons = $filterForm.find('input[type=submit],button').attr('disabled', 'disabled');
      const loadingAnimationHelper = new LoadingAnimationHelper();
      loadingAnimationHelper.appendLoadingAnimation($ajaxTarget);

      this.filterRequestCount++; // check for current request result
      const currentFilterRequestCount = this.filterRequestCount;
      if (this.currentFilterRequest) { // abort if async request is running
        this.currentFilterRequest.abort();
        this.isLoadingMore = true;
        this.submitDataCache = '';
      }

      this.currentFilterRequest = $.ajax({
        url: actionUrl,
        method: $filterForm.attr('method'),
        data: formSubmitData,
        dataType: 'html',
        error: () => {
          this.isLoadingMore = false;
        },
      }).done((data) => {
        const loadingAnimationHelperInner = new LoadingAnimationHelper();
        loadingAnimationHelperInner.removeLoadingAnimation($ajaxTarget);
        if (currentFilterRequestCount === this.filterRequestCount) {
          this.currentFilterRequest = null;
          this.processAjaxResponse($filterForm, data, $ajaxTarget);
        }
      }).always(() => {
        $buttons.removeAttr('disabled');
      });
    }
  }

  /**
   * @param {jQuery} $filterForm
   * @param {string} responseData
   * @param {jQuery} $ajaxTarget
   */
  processAjaxResponse($filterForm, responseData, $ajaxTarget) {
    let internalResponseData = responseData;
    // signal beforeShowResults
    $.each(this.signals.validateShowResults, (key, callback: any) => {
      internalResponseData = callback(internalResponseData);
    });
    $.each(this.signals.beforeShowResults, (key, callback: any) => {
      internalResponseData = callback(internalResponseData, $ajaxTarget);
    });
    let hasList = false;
    Array.prototype.forEach.call($ajaxTarget[0].children, (elem) => {
      if (elem.classList.contains('ext__ajaxList') && !hasList) {
        hasList = true;
        internalResponseData = $(internalResponseData).children();
      }
    });
    if (hasList) {
      $ajaxTarget.find('.' + 'ext__ajaxList').append(internalResponseData);
    } else {
      $ajaxTarget.append(internalResponseData);
    }
    this.isLoadingMore = false;
    let ulList = $(responseData)[0];
    if (ulList) {
      let href = ulList.getAttribute('data-link-next-page');
      if (!href) {
        href = '';
      }
      $filterForm.attr('data-paginate-next-link', href);
    } else {
      $filterForm.removeAttr('data-paginate-next-link');
    }
    this.getOnScrollFunction($filterForm)();
    // signal afterShowResults

    $.each(this.signals.afterShowResults, (key, callback: any) => {
      callback(internalResponseData, $ajaxTarget);
    });
  }

  /**
   * This will bes used if ajax is disabled
   *
   * @param {jQuery} $elements
   * @param {jQuery} $filterForm
   */
  filterElementsByClass($elements, $filterForm) {
    const filterFormHash = new FilterFormHash();
    filterFormHash.addFormValues(
      $filterForm.attr('data-filter-form-prefix'),
      $filterForm.find(this.filterInputSelector),
      false,
    );
    const selector = filterFormHash.getClassSelector();
    if (selector === '') {
      $elements.show();
    } else {
      $elements.hide().filter(selector).show();
    }
  }

  /**
   * @param {jQuery} $filterForm Form element
   * @param {boolean} triggerChange
   */
  setFilterFormFromHash($filterForm, triggerChange) {
    let internalTriggerChange = triggerChange;
    // noinspection JSUnusedAssignment
    this.enableChangeListener = false;
    if (window.location.hash.length > 1) {
      const filterFormHash = new FilterFormHash();
      filterFormHash.setFormFieldsFromHash(window.location.hash, $filterForm.find(this.filterInputSelector), $filterForm.attr('data-filter-form-prefix'));
    } else {
      internalTriggerChange = false;
    }
    $.each(this.signals.afterSetFilterFormFromHash, (key, callback: any) => {
      callback($filterForm);
    });
    this.enableChangeListener = true;
    if (internalTriggerChange === true) {
      $(window).trigger('hashchange');
    }
  }

  /**
   * @param {jQuery} $filterForm
   */
  getOnScrollFunction($filterForm) {
    return () => {
      if (!this.isLoadingMore && $filterForm.attr('data-paginate-next-link')) {
        const children = $($filterForm.attr('data-ajax-target')).children();
        let posLastChild = 0;
        if ($(children[1]).find('li:last-of-type')[0]) {
          posLastChild = $(children[1]).find('li:last-of-type')[0].offsetTop;
        }
        const scrollTop = $(window).scrollTop();
        const height = $(window).height();
        let windowBottom = 0;
        if (scrollTop && height) {
          windowBottom = scrollTop + height;
        }

        if (posLastChild > 0 && windowBottom > posLastChild) {
          this.isLoadingMore = true;
          this.sendAjaxRequest($filterForm, $filterForm.attr('data-paginate-next-link'));
        }
      }
    };
  }

  /**
   * Submit form
   *
   * @param {jQuery} $filterForm
   */
  setHashFromFilterForm($filterForm) {
    const filterFormHash = new FilterFormHash();
    let internal$FilterForm = $filterForm;

    $.each(this.signals.beforeSetHashFromFilterForm, (key, callback: any) => {
      internal$FilterForm = callback(internal$FilterForm);
    });

    filterFormHash.addFormValues(
      internal$FilterForm.attr('data-filter-form-prefix'),
      internal$FilterForm.find(this.filterInputSelector),
      true,
    );

    // noinspection JSUnusedAssignment
    this.enableHashListener = false;
    const hash = filterFormHash.getHash();

    if (window.history.pushState) {
      // Update the address bar
      const newUrl = window.location.href.split('#')[0] + (hash ? ('#' + hash) : '');
      window.history.pushState({}, '', newUrl);
    } else {
      // Fallback for poor browsers which do not have pushState
      window.location.hash = hash;
    }

    this.enableHashListener = true;
    $(window).trigger('hashchange');
  }
}
